import { render, staticRenderFns } from "./SignatureEditor.vue?vue&type=template&id=4c984908&scoped=true"
import script from "./SignatureEditor.vue?vue&type=script&lang=js"
export * from "./SignatureEditor.vue?vue&type=script&lang=js"
import style0 from "./SignatureEditor.vue?vue&type=style&index=0&id=4c984908&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c984908",
  null
  
)

export default component.exports